import { render, staticRenderFns } from "./NavBarLeft.vue?vue&type=template&id=21e2c3d8"
import script from "./NavBarLeft.vue?vue&type=script&lang=js"
export * from "./NavBarLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports